import { fbt } from 'fbtee'
import type { TotemBorderStyle } from '../../types'

// Excludes rose-ish / emerald-ish to avoid confusion with interested/going borders
export const SOLID_COLORS = [
  '#ff0000', '#ff5722', '#ff8800', '#f59e0b', '#ffcc00', '#8bc34a',
  '#00bcd4', '#0088ff', '#6366f1', '#9c27b0', '#cc44ff', '#d946ef',
]

export const GRADIENT_COLORS = [
  '#ff3366', '#ff5722', '#ff8800', '#ffcc00', '#8bc34a', '#00cc88',
  '#00bcd4', '#0088ff', '#6366f1', '#9c27b0', '#cc44ff', '#d946ef',
]

export type BorderType = TotemBorderStyle['type']

export function borderLabel(style: TotemBorderStyle): string {
  switch (style.type) {
    case 'rainbow':
      return fbt('Rainbow', 'Label for the rainbow border style')
    case 'solid':
      return fbt('Solid', 'Label for the solid color border style')
    case 'gradient':
      return fbt('Gradient', 'Label for the gradient border style')
  }
}
